import { appVersionApi } from 'src/api';

const api = {
  getAppVersion: async () => {
    return await appVersionApi.getAppVersion();
  }
};

export default api;
